import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  width: '100%'
});

export const IconWrapper = styled(Box)({
  display: 'flex',
  flexShrink: 0,
  marginTop: '3px'
});

export const Texts = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px'
});

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  fontFamily: theme.typography.body2B.fontFamily,
  color: theme.palette.brand.darkGreen
}));
